module.exports = __webpack_public_path__ + "static/media/computers3.feab607d.png";